module.exports = {
    theme: {
        extend: {
            screens: {
                xs: { max: '639px' },
            },
            colors: {
                palette: {
                    green: '#89c429',
                    blue: '#4dc4e4',
                    orange: '#ffa702',
                    pink: '#dc3f9e',
                    beige: '#fff3dd',
                },
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            },
            opacity: {
                5: '.05',
                60: '.6',
                80: '.8',
            },
            spacing: {
                18: '4.5rem',
                22: '5.5rem',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
